class DropdownItem<TModel> {
    public Item: TModel;
    public Active: boolean;
    public CssClass?: string;

    public constructor(fields?: Partial<DropdownItem<TModel>>) {
        Object.assign(this, fields);
    }
}

export { DropdownItem };
